const BaseModule = require('../../90_utils/base/BaseModule');

class ImgCover extends BaseModule {

	constructor(el, params) {

		super(el);

		this.contentRatio;
		this.centerX = 0.5;
		this.centerY = 0.5;

		this._checkContentRatio();
	}

	// basemodule methods

	_domReady(){ }

	_checkContentRatio(){

		let el = this.$el[0];
		if(el.complete){
			this.contentRatio = el.naturalWidth / el.naturalHeight;
			this._resize();
			this.$el.addClass('is-loaded');
		}
	}

	_addListeners(){

		let el = this.$el[0];

		this.$el.on('imageChange', $.proxy(this._onImageChange, this));
		this.$el.on('load', (e) => {
			this.contentRatio = el.naturalWidth / el.naturalHeight;
			this._resize();
			this.$el.addClass('is-loaded');
		});
	}
	_removeListeners(){ }

	_onImageChange(e){

	}

	_show(){ }
	_hide(){ }

	_enable(){ }
	_disable(){ }

	_domUpdate(){ }
	_resize(){

		if(this.contentRatio){
			let $parent = this.$el.parent();
			window.utils.PositioningUtils.fitToObject(this.$el, $parent, this.contentRatio, this.centerX, this.centerY, true);
		}
	}
}

module.exports = ImgCover;
